import Trans from "features/translation/components/Trans";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";
import Dialog from "components/ui/Dialog/Dialog";

const ProfileDeletedExplain = () => {
  const { hideDialog } = useDialog();

  return (
    <Dialog title={ `Uw profiel is verwijderd` }>
      <>
        <div className={ 'dialog__intro' }>
          <Trans
            text={ 'Jammer dat Trefpunt niet aan uw verwachtingen voldoet. Mocht u zich in een later stadium weer willen inschrijven op Trefpunt, kan dat natuurlijk altijd.' }/>
        </div>
        <div className={ 'dialog__buttons' }>
          <Button onClick={ hideDialog } variant={ 'secondary' }>Sluiten</Button>
        </div>
      </>
    </Dialog>
  )
}

export default ProfileDeletedExplain;
